import { render, staticRenderFns } from "./unionPayMerchant.vue?vue&type=template&id=6dc57d24&scoped=true&"
import script from "./unionPayMerchant.vue?vue&type=script&lang=js&"
export * from "./unionPayMerchant.vue?vue&type=script&lang=js&"
import style0 from "./unionPayMerchant.vue?vue&type=style&index=0&id=6dc57d24&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dc57d24",
  null
  
)

export default component.exports